module.exports = __webpack_public_path__ + "media/images/2023/2023-keyvisual-0987d0751e637191904e5b0ba74174cc.jpg";